// extracted by mini-css-extract-plugin
module.exports = {"form_container":"ForgotPasswordPanel_form_container__1jzL_"};